import React from 'react';
import { Button, DialogActions } from '@mui/material';

type EditReceiptDialogActionsProps = {
  previewUrl: string;
  uploading: boolean;
  modeSwitching: boolean;
  perspectiveLoading: boolean;
  locationRequired: boolean;
  selectedLocationId: string;
  locationsLoading: boolean;
  locationsResolved: boolean;
  onCancel: () => void;
  onSubmit: () => void;
};

const EditReceiptDialogActions: React.FC<EditReceiptDialogActionsProps> = React.memo(({
  previewUrl,
  uploading,
  modeSwitching,
  perspectiveLoading,
  locationRequired,
  selectedLocationId,
  locationsLoading,
  locationsResolved,
  onCancel,
  onSubmit,
}) => {
  return (
    <DialogActions sx={{ p: 3, pt: 1 }}>
      <Button
        variant="outlined"
        onClick={onCancel}
        disabled={uploading || modeSwitching}
        size="large"
        sx={{
          color: '#2C6CA0',
          borderColor: 'grey.300',
          borderRadius: '8px',
          textTransform: 'none',
          backgroundColor: '#ffffff',
          fontWeight: 600,
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        disabled={
          !previewUrl
          || uploading
          || modeSwitching
          || perspectiveLoading
          || locationsLoading
          || !locationsResolved
          || (locationRequired && !selectedLocationId)
        }
        sx={{
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '15px',
          backgroundColor: '#2C6CA0',
        }}
      >
        {uploading ? 'Processing...' : 'Upload & Process'}
      </Button>
    </DialogActions>
  );
});

EditReceiptDialogActions.displayName = 'EditReceiptDialogActions';

export default EditReceiptDialogActions;
